import React, { Component } from "react";

import CompanySelect from "../CompanySelect";
import { FormattedMessage } from "react-intl";
import SweetAlert from "react-bootstrap-sweetalert";

// eslint-disable-next-line

const CompanySwitcherAlert = ({ hideAlert, userId }) => {
  //  console.log('CompanySwitcherAlert', userId);

  return (
    <FormattedMessage
    /*id="CompanySwitcher_title"
      defaultMessage="Sélectionnez une entreprise"
      description="title of modal window inviting user to select another company"
      */
    >
      {title => (
        <SweetAlert
          style={{ height: 400, display: "block", marginTop: "-100px" }}
          //        style={{ width: 1000,   display: "block", marginTop: "-100px" }}
          title={title}
          onConfirm={() => hideAlert()}
          onCancel={() => hideAlert()}
          confirmBtnBsStyle="info"
          showConfirm={false}
          showCancel>
          <CompanySelect userId={userId} onSelected={hideAlert} />
        </SweetAlert>
      )}
    </FormattedMessage>
  );
};

class CompanySwitcher extends Component {
  hideAlert = () => {
    this.props.onHidden();
  };

  render() {
    //    console.log('CompanySwitcher', this.props)
    return (
      <div>
        {this.props.show && (
          <CompanySwitcherAlert
            hideAlert={this.hideAlert}
            userId={this.props.userId}
          />
        )}
      </div>
    );
  }
}

export default CompanySwitcher;
